export class View2DSetting {

    
    public zoomSpeed: number = 1.2;
    public minZoomValue: number = 0.5;
    public maxZoomValue: number = 2;

}